import type { HighlightVideo } from '@/domain/player'

/**
 * ハイライト動画は本Issue（#9）の対象外（実データ化はADR-0004・別Issue）のため、
 * 引き続きモックデータを使う。選手一覧・成績はIssue #7・#9で実データ（npb.jp）に
 * 差し替え済み（旧 `MOCK_PLAYERS` / `MOCK_STATUS` は削除した）。
 */
export const MOCK_VIDEOS: Record<string, HighlightVideo[]> = {
  '41045153': [
    {
      videoId: 'mock-video-1',
      title: '佐藤輝明 第39号本塁打 vs 巨人',
      thumbnailUrl: 'https://placehold.co/320x180?text=Highlight',
      embeddable: true,
      publishedAt: '2026-09-17T20:00:00Z',
    },
  ],
}
